"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@aws-amplify/core");

var AuthPiece_1 = require("./AuthPiece");

var Amplify_UI_Components_React_1 = require("../Amplify-UI/Amplify-UI-Components-React");

var logger = new core_1.ConsoleLogger('Loading');

var Loading =
/** @class */
function (_super) {
  __extends(Loading, _super);

  function Loading(props) {
    var _this = _super.call(this, props) || this;

    _this._validAuthStates = ['loading'];
    return _this;
  }

  Loading.prototype.showComponent = function (theme) {
    var hide = this.props.hide;

    if (hide && hide.includes(Loading)) {
      return null;
    }

    return React.createElement(Amplify_UI_Components_React_1.FormSection, {
      theme: theme
    }, React.createElement(Amplify_UI_Components_React_1.SectionBody, {
      theme: theme
    }, core_1.I18n.get('Loading...')));
  };

  return Loading;
}(AuthPiece_1.default);

exports.default = Loading;